import { useActiveMember } from 'hooks/store';

// TODO change to use a stubbed position or highest level position (requires querying and this hook is used everywhere would probably need to lift)
export default function useActivePosition() {
  return useActiveMember().position;
}
